import { createStore } from '@souche-f2e/muji';
import {
  queryAppTraffic,
  resetTraffic
} from '../services/traffic';
import {  message } from 'antd';
import { queryTrafficStat } from '../services/stat';

const state = {
  appTraffic: null,
  queryInfo: {
    rangeType: 'day',
    rangeStart: '',
    rangeEnd: '',
    appKey: '',
    toGetRows: false,
    orderBy: "DESC"
  },

  trafficStat: []
};


export default createStore({
  state,

  // reducers
  reducers: {

    SET_APP_TRAFFIC_INFO(state, {
      appTraffic
    }) {
      return {
        ...state,
        appTraffic
      }
    },

    RESET_APP_USED(state) {
      state.appTraffic.trafficUsed = 0;
    },

    SET_TRAFFIC_STAT(state, { trafficStat }){
      return {
        ...state,
        trafficStat
      }
    },

    SET_DAY_CYCLE(state, { queryInfo }){
      return {
        ...state,
        queryInfo: {
          ...state.queryInfo,
          ...queryInfo
        }
      }
    }
  },

  // effects
  effects: {

    async getAppTraffic(appKey) {
      const body = await queryAppTraffic(appKey).promise;
      const {
        success,
        data
      } = body;
      if (success) {
        this.SET_APP_TRAFFIC_INFO({
          appTraffic: data
        })
      } else {
        this.SET_APP_TRAFFIC_INFO({
          appTraffic: null
        })
      }
    },

    async resetTraffic(params) {
      const {
        type,
        appKey,
        apiId,
        uri,
        method
      } = params;

      const body = await resetTraffic(type, appKey, apiId, uri, method).promise;

      const {
        success
      } = body;

      if (success) {
        message.info('设置成功!');
        this.RESET_APP_USED();
      } else {
        message.error('设置失败!');
      }
    },

    async queryTrafficStat(params){
      const body = await queryTrafficStat(params).promise;
      const {
        success,
        data
      } = body;
      if (success) {
        this.SET_TRAFFIC_STAT({
          trafficStat: data
        })
      } else {
        this.SET_TRAFFIC_STAT({
          trafficStat: []
        })
        message.error('请完善搜索条件');
      }
    },
  }
});
